import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VigiComponent } from './vigi.component';
import { ProductQueriesComponent } from './product-queries/product-queries.component';

const routes: Routes = [
  {
    path: 'vigi', component: VigiComponent,
    children: [
      { path: '', redirectTo: 'product-queries', pathMatch: 'full' },
      { path: 'product-queries', component: ProductQueriesComponent }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VigiRoutingModule { }
